import { FC } from 'react';
import {
  BooleanInput,
  FormDataConsumer,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
} from 'react-admin';

export const UpdateChannelPutForm: FC<Omit<SimpleFormProps, 'children'>> = () => {
  return (
    <SimpleForm>
      {/* Uniqueness is the one rule on `name` this form cannot check before submitting, so the hint
          warns up front and react-admin swaps it for the server's 422 message afterwards (TVR-1351). */}
      <TextInput source="name" fullWidth helperText="resources.update_channels.helpers.name_unique" />
      <TextInput source="short_name" fullWidth />
      <ReferenceInput source="hardware_id" reference="hardware">
        <SelectInput optionText="name" fullWidth />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.hardware_id && (
            <ReferenceInput
              source="hardware_revision_id"
              reference="hardware_revisions"
              filter={{ hardware_id: formData.hardware_id }}
            >
              <SelectInput optionText="name" fullWidth />
            </ReferenceInput>
          )
        }
      </FormDataConsumer>
      <BooleanInput source="active" />
    </SimpleForm>
  );
};
